import { FC } from 'react';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuestionIndex, selectQuestionsLength, selectQuiz } from 'store/quiz/quizSelectors';
import { selectQuestionReady } from 'store/player/playerSelectors';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  width: number;
  score: number;
  groupsLength: number;
  submittedGroupsLength: number;
}

const QuestionScoringBar:FC<Props> = ({ width, score, groupsLength, submittedGroupsLength }) => {
  const { t } = useTranslation();

  const quiz:IQuiz = useAppSelector(selectQuiz);
  const questionReady:boolean = useAppSelector(selectQuestionReady);
  const questionsLength:number = useAppSelector(selectQuestionsLength);
  const currentQuestionIndex = useAppSelector(selectQuestionIndex);

  if ( !questionReady ) return null;
  return (
    <div>
      {quiz.questionsSettings.timeout ? (
        <div className="flex items-center gap-4">
          <span className="text-primary text-sm font-bold">
            {currentQuestionIndex}&nbsp;/&nbsp;{questionsLength}
          </span>
          <div
            className="relative w-full bg-gray-200 border-4 border-gray-200 h-6 rounded-lg"
            style={{ marginBottom: 2 }}
          >
            <div className="absolute top-0 left-0 w-full h-4 opacity-25 rounded z-0" style={{ backgroundColor: quiz.theme.progressBarColor }}></div>
            <div className="absolute top-0 left-0 h-4 rounded z-10" style={{ width: `${width}%`, backgroundColor: quiz.theme.progressBarColor }}></div>
          </div>
          <div className="flex flex-col text-primary w-12">
            <span className="text-xss leading-4 text-center">{t('labels.score')}</span>
            <span className="text-sm leading-4 text-center font-bold">{score}</span>
          </div>
        </div>
      ) : null}
      <div className="flex gap-4 justify-between my-4 px-4">
        {Array.from({ length: groupsLength }, (_, i) => (
          <div
            key={`group-indicator-${i}`}
            className={`
              w-10 h-10
              rounded-full shadow-primary
              border-2 border-white
              ${submittedGroupsLength > i ? 'bg-white' : ''}
            `}
          />
        ))}
      </div>
    </div>
  )
}

export default QuestionScoringBar;
